
export default [
  {
    "title": "DnsBuddy.co",
    "description": "I decided to refactor this entire project using Golang and Tanstack. As of right now, I have decided to make this project closed source.",
    "website": "https://dnsbuddy.co",
    "openSource": false,
    "active": true,
    "visible": true,
    "date": new Date("2025-08-09T00:00:00.000Z"),
    "technologies": [
      "tanstack",
      "react",
      "tailwindcss",
      "postgres",
      "golang"
    ],
    "featured": false,
    "content": "",
    "_meta": {
      "filePath": "dnsbuddy.co-saas.mdx",
      "fileName": "dnsbuddy.co-saas.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "dnsbuddy.co-saas"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  },
  {
    "title": "DnsBuddy.co",
    "description": "Created a tool to help people with validating DNS Records across multiple DNS Providers, looking up WHOIS information and more. This was a fun project to build and learn about DNS and specifically DoH (DNS over HTTPS).",
    "website": "https://dnsbuddy.co",
    "openSource": true,
    "githubUrl": "https://github.com/baker/dnsbuddy.co",
    "active": false,
    "visible": true,
    "date": new Date("2023-09-16T00:00:00.000Z"),
    "technologies": [
      "nextjs",
      "react",
      "tailwindcss"
    ],
    "featured": false,
    "content": "",
    "_meta": {
      "filePath": "dnsbuddy.co.mdx",
      "fileName": "dnsbuddy.co.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "dnsbuddy.co"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  },
  {
    "title": "dotfiles",
    "description": "This is my attempt at simplifying my life across the various systems I code on. I've been using this for a few years now and it's been a great way to keep my systems in sync.",
    "openSource": true,
    "githubUrl": "https://github.com/baker/dotfiles",
    "active": true,
    "visible": true,
    "date": new Date("2023-12-14T00:00:00.000Z"),
    "technologies": [
      "script"
    ],
    "featured": false,
    "content": "",
    "_meta": {
      "filePath": "dotfiles.mdx",
      "fileName": "dotfiles.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "dotfiles"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  },
  {
    "title": "EmailGuard.co",
    "description": "An email validation API that checks syntax, disposable inboxes, and classifies relay and role addresses in a single request—so every signup, lead, and checkout starts clean.",
    "website": "https://emailguard.co",
    "openSource": false,
    "active": true,
    "visible": true,
    "date": new Date("2026-08-03T00:00:00.000Z"),
    "technologies": [
      "golang",
      "react",
      "postgres",
      "tailwind",
      "tanstack"
    ],
    "featured": false,
    "content": "",
    "_meta": {
      "filePath": "emailguard.co.mdx",
      "fileName": "emailguard.co.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "emailguard.co"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  },
  {
    "title": "Example",
    "description": "Example Project",
    "website": "https://example.com",
    "openSource": false,
    "githubUrl": "https://github.com/baker/example",
    "active": false,
    "visible": false,
    "date": new Date("2023-09-16T00:00:00.000Z"),
    "technologies": [
      "rss",
      "css"
    ],
    "featured": false,
    "content": "",
    "_meta": {
      "filePath": "example.mdx",
      "fileName": "example.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "example"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  },
  {
    "title": "FrancisPBaker.com",
    "description": "This is the source code for this site. The goal of this site was to be my archive, both professionally and personally.",
    "website": "https://FrancisPBaker.com",
    "openSource": false,
    "active": true,
    "visible": true,
    "date": new Date("2022-05-01T00:00:00.000Z"),
    "technologies": [
      "tanstack",
      "react",
      "tailwindcss"
    ],
    "featured": false,
    "content": "",
    "_meta": {
      "filePath": "francispbaker.com.mdx",
      "fileName": "francispbaker.com.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "francispbaker.com"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  },
  {
    "title": "InboundParse.com",
    "description": "Building on top of Email has never been easier. I decided to build a tool that would allow anyone to easily parse inbound emails and forward them to a webhook, telegram, slack, and dozen other services.",
    "website": "https://inboundparse.com",
    "openSource": false,
    "active": true,
    "visible": false,
    "date": new Date("2025-07-21T00:00:00.000Z"),
    "technologies": [
      "tanstack",
      "react",
      "tailwindcss",
      "postgres",
      "golang"
    ],
    "featured": false,
    "content": "",
    "_meta": {
      "filePath": "inboundparse.com.mdx",
      "fileName": "inboundparse.com.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "inboundparse.com"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  },
  {
    "title": "InboundParse",
    "description": "Open-source inbound email parser, receive SMTP mail, normalize the payload, and POST the message plus metadata to a webhook you own for automations and integrations.",
    "openSource": true,
    "githubUrl": "https://github.com/baker/inboundparse",
    "active": true,
    "visible": true,
    "date": new Date("2025-07-21T00:00:00.000Z"),
    "technologies": [
      "golang"
    ],
    "featured": true,
    "content": "",
    "_meta": {
      "filePath": "inboundparse.mdx",
      "fileName": "inboundparse.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "inboundparse"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  },
  {
    "title": "ineedatest.email",
    "description": "Disposable test inboxes that clean up after themselves, so you can grab an address when you need one without mail piling up forever in a third-party inbox.",
    "website": "https://ineedatest.email",
    "openSource": false,
    "active": true,
    "visible": true,
    "date": new Date("2026-05-05T00:00:00.000Z"),
    "technologies": [
      "golang",
      "react",
      "postgres",
      "tailwind",
      "tanstack"
    ],
    "featured": false,
    "content": "",
    "_meta": {
      "filePath": "ineedatest.email.mdx",
      "fileName": "ineedatest.email.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "ineedatest.email"
    },
    "tableOfContents": [],
    "mdx": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;"
  }
]